import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaFinalidade from '../../../../../lib/json/consultas/Finalidade.json'
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import { ConsultaTotvsEmpresa } from "../../../../../backend/ConsultaTotvsEmpresa";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../../components/BootBox";

function ListaFinalidade(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const columns = [
        // {
        //     Header: 'Filial',
        //     accessor: 'DHK_FILIAL',
        // },
        {
            Header: 'Finalidade',
            accessor: 'DHK_CODIGO',
        },
        {
            Header: 'Descrição',
            accessor: 'DHK_DESCR',
        },
        {
            Header: 'Dias SLA',
            accessor: 'DHK_XDSLA',
        }
        // {
        //     Header: 'Produto Inicio',
        //     accessor: 'DHK_XPRDIN',
        // },
        // {
        //     Header: 'Produto Fim',
        //     accessor: 'DHK_XPRDFN',
        // }
    ];
    
    var [carregar, setCarregar] = useState(false);
    var [data, setData]   = useState([]);
    var consultaDefault  = ConsultaFinalidade.consulta + "WHERE D_E_L_E_T_ <> '*' AND DHK_ATIVO != '2' ";

    useEffect(() => {
        loadFinalidade();
    }, []);

    // Processa consulta do grid
    const loadFinalidade = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaFinalidade.tabelas )
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.DHK_CODIGO.trim()}/${row.original.EMPRESA}${row.original.M0_CODFIL.trim()}`)
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage 
                    text="Finalidade"
                />
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadFinalidade}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaFinalidade;